export const getMetricsRoute = '/enterprise/enterprises-metrics/';
